import React from 'react';
import { canonicalFor, usePageMeta } from '../../hooks/usePageMeta';
import { PageHeader } from '../../components/page/PageHeader';
import { ContentSection } from '../../components/page/ContentSection';
import { CatalogTable } from '../../components/page/CatalogTable';
import { SalesCallout } from '../../components/page/SalesCallout';
import { RelatedLinks } from '../../components/page/RelatedLinks';
import { catalog } from '../../data/catalog';
export function Accessories() {
  usePageMeta({
    title: 'Shear Geometry Accessories: T-15 Driver & 4-15 Screw | Robertson Precision',
    description: 'Shear Geometry service parts: the T-15 Torx driver and the 4-15 insert screw with a low-profile head. Call 800-397-7745 to confirm the correct parts.',
    canonical: canonicalFor('/products/accessories/')
  });
  return <>
      <PageHeader eyebrow="Products" title="Accessories" lead="Service parts for installing and replacing inserts: the Torx driver and the low-profile insert screw." crumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Products',
      href: '/products/'
    }, {
      label: 'Accessories'
    }]} data-id="element-785" data-mp="2jf5almf8s730" />

      <ContentSection id="parts" title="Service parts" intro={<p data-id="element-787" data-mp="3dbk6p5skbx6q">
            Confirm the correct service parts for your holder with sales before
            ordering.
          </p>} data-id="element-786" data-mp="3hde2aznwib01">
        <CatalogTable rows={catalog.filter(c => c.category === 'accessories')} caption="Shear Geometry accessories" data-id="element-788" data-mp="2pm7wq3pevl3d" />
        <div className="mt-10" data-id="element-789" data-mp="2ydrryfuubctl">
          <SalesCallout location="accessories" data-id="element-790" data-mp="2yf1q151p0l08" />
        </div>
      </ContentSection>

      <RelatedLinks links={[{
      label: 'Tool Holders',
      href: '/products/holders/',
      description: 'Each holder includes a Torx driver.'
    }, {
      label: 'Inserts & Chipbreakers',
      href: '/products/inserts/',
      description: 'APGX inserts, sold in boxes of 10.'
    }, {
      label: 'Starter Kits',
      href: '/products/starter-kits/',
      description: 'Kits include extra screws.'
    }, {
      label: 'Contact',
      href: '/contact/',
      description: 'Sales and technical assistance.'
    }]} data-id="element-791" data-mp="2tn1l0y6rn1ws" />
    </>;
}